import _ from 'lodash'

const formatNumber = (number: string, length: number) => {
	return _.padStart(number, length, '0')
}

export default formatNumber